import Link from 'next/link';
import React from 'react';
import { CoachIcon } from '../svg/CoachIcon';
import { GamerIcon } from '../svg/GamerIcon';

type Props = {
    className?: string;
};

export const CollegeWScholar: React.FC<Props> = ({ className }) => {
    return (
        <div className="college-with-main">
            <div className="container slim">
                <div className="content">
                    <h2 className="scholar-tagline">{'COLLEGES CURRENTLY OFFERING ESPORTS SCHOLARSHIPS'}</h2>
                    <p className="scholar-description">{`Easily be able to find and connect with colleges by using the search functionality on the "Colleges" page on the website. Not only can you filter by scholarship, but you can also filter by game title and international schools.`}</p>
                    <Link href={'/colleges'}>
                        <a className="button blue-button large-button">Find Colleges</a>
                    </Link>
                </div>
            </div>
        </div>
    );
};
